import React from "react";
import cn from "classnames";
import { buttonVariants } from "theme/buttonVariants";

const ImageAndTextComponent = ({
    state: {
        url = "",
        mobileUrl = "",
        mobileImagePosition = "center",
        imageAndTextHeading = "",
        imageAndTextHeadingColour = "text-brand-black",
        imageAndTextSubHeading = "",
        imageAndTextSubHeadingColour = "text-brand-white",
        imageAndTextText = "",

        imageAndTextButtonText = "",
        imageAndTextButtonColour = "primary",
        imageAndTextButtonLink = "",
    },
}) => {
    return (
        <div
            className="relative flex flex-col lg:items-start justify-start lg:justify-center p-[30px] lg:p-[60px] rounded-[10px] aspect-[355/450] sm:aspect-[1320/650]"
            style={{ backgroundColor: "#ddd" }}
        >
            <div className="flex flex-col gap-[10px] lg:max-w-[536px] z-10 items-start">
                <div className="flex flex-col">
                    {imageAndTextHeading && (
                        <h2
                            className={cn(
                                `!text-[30px] !leading-[36px] lg:!text-[40px] lg:!leading-[46px] uppercase mb-0`,
                                imageAndTextHeadingColour
                            )}
                        >
                            {imageAndTextHeading}
                        </h2>
                    )}

                    {imageAndTextSubHeading && (
                        <h2
                            className={cn(
                                `!text-[30px] !leading-[36px] lg:!text-[40px] lg:!leading-[46px] uppercase mb-0`,
                                imageAndTextSubHeadingColour
                            )}
                        >
                            {imageAndTextSubHeading}
                        </h2>
                    )}
                </div>

                {imageAndTextText && (
                    <p className="text-brand-white text-base lg:text-[20px] leading-[22px] lg:leading-[26px]">
                        {imageAndTextText}
                    </p>
                )}
                {imageAndTextButtonLink && (
                    <a
                        href={imageAndTextButtonLink}
                        className={cn(
                            buttonVariants[imageAndTextButtonColour],
                            "!text-brand-white !no-underline hover:text-brand-white !hover:font-bold !border-transparent !font-bold mt-[15px]"
                        )}
                    >
                        {imageAndTextButtonText}
                    </a>
                )}
            </div>

            {url && (
                <img
                    src={url}
                    className={cn(
                        "absolute top-0 left-0 w-full h-full object-cover rounded-[10px]",
                        {
                            "hidden lg:block": !!mobileUrl,
                            "object-left lg:object-center":
                                mobileImagePosition === "left",
                            "object-center": mobileImagePosition === "center",
                            "object-right lg:object-center":
                                mobileImagePosition === "right",
                        }
                    )}
                    alt="Background"
                />
            )}

            {mobileUrl && (
                <img
                    src={mobileUrl}
                    className={cn(
                        "absolute top-0 left-0 w-full h-full object-cover rounded-[10px] block lg:hidden",
                        {
                            "object-left lg:object-center":
                                mobileImagePosition === "left",
                            "object-center": mobileImagePosition === "center",
                            "object-right lg:object-center":
                                mobileImagePosition === "right",
                        }
                    )}
                    alt="Background"
                />
            )}
        </div>
    );
};

export default ImageAndTextComponent;
